import React, { FC } from 'react'

import { GROUP_PLAN_SUPPORT_ARTICLE } from '@smarty-nx/code-utils'
import { Button, Modal, Typography } from '@smarty-nx/ds'
import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'

import { content } from './index.content'
import classes from './index.module.scss'
import { GroupPlanModalProps } from './index.types'
import shots2 from '../../../../static/assets/images/landing-pages/shots-2-modal.svg'

export const GroupPlanModal: FC<GroupPlanModalProps> = ({
  showModal,
  onHideModal,
  modalType,
}) => {
  const userTypeContent = content.contentByUserType[modalType]

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={onHideModal}
      testId="group-plan-alert-modal"
      closeButtonClassName={classes.closeButton}
      modalClassName={classes.root}
    >
      <div className={classes.content}>
        <img src={shots2} alt="banner" className={classes.image} />
        <div className={classes.text}>
          <Typography
            variant="Kollektif/HeaderText2XlBold"
            component="h3"
            data-testid="modal-header"
            className={classes.header}
          >
            {userTypeContent.title}
          </Typography>
          <Typography
            variant="Kollektif/Small"
            component="div"
            data-testid="modal-details"
            className={classes.details}
          >
            {userTypeContent.details}
          </Typography>
        </div>
        <div>
          <Button
            data-testid="group-plan-support-button"
            data-item-name="group-plan-support"
            data-item-category={TRACKING_CATEGORIES.NAVIGATION}
            className={classes.primaryButton}
            onClick={onHideModal}
            as={(props) => (
              <a
                href={GROUP_PLAN_SUPPORT_ARTICLE}
                rel="noopener noreferrer"
                target="_blank"
                {...props}
              >
                {content.cta}
              </a>
            )}
          />
        </div>
      </div>
    </Modal>
  )
}
